// tslint:disable
/// <reference path="./custom.d.ts" />
/**
 * StoreCMS
 * MONET Store Contents API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as globalImportUrl from 'url';
import { Configuration } from './configuration';
import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from './base';

/**
 * 
 * @export
 * @interface CustomField
 */
export interface CustomField {
    /**
     * 
     * @type {string}
     * @memberof CustomField
     */
    fieldId: string;
}
/**
 * 
 * @export
 * @interface Docs
 */
export interface Docs {
    /**
     * 
     * @type {Array<string>}
     * @memberof Docs
     */
    section: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof Docs
     */
    order: number;
    /**
     * 
     * @type {string}
     * @memberof Docs
     */
    title: string;
    /**
     * 
     * @type {Array<DocsParagraph>}
     * @memberof Docs
     */
    body: Array<DocsParagraph>;
    /**
     * 
     * @type {string}
     * @memberof Docs
     */
    id: string;
    /**
     * 
     * @type {Date}
     * @memberof Docs
     */
    createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof Docs
     */
    updatedAt: Date;
}
/**
 * 
 * @export
 * @interface DocsAllOf
 */
export interface DocsAllOf {
    /**
     * 
     * @type {Array<string>}
     * @memberof DocsAllOf
     */
    section: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof DocsAllOf
     */
    order: number;
    /**
     * 
     * @type {string}
     * @memberof DocsAllOf
     */
    title: string;
    /**
     * 
     * @type {Array<DocsParagraph>}
     * @memberof DocsAllOf
     */
    body: Array<DocsParagraph>;
}
/**
 * 
 * @export
 * @interface DocsParagraph
 */
export interface DocsParagraph {
    /**
     * 
     * @type {string}
     * @memberof DocsParagraph
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof DocsParagraph
     */
    body: string;
    /**
     * 
     * @type {string}
     * @memberof DocsParagraph
     */
    fieldId: string;
}
/**
 * 
 * @export
 * @interface DocsParagraphAllOf
 */
export interface DocsParagraphAllOf {
    /**
     * 
     * @type {string}
     * @memberof DocsParagraphAllOf
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof DocsParagraphAllOf
     */
    body: string;
}
/**
 * 
 * @export
 * @interface GetDocsResponse
 */
export interface GetDocsResponse {
    /**
     * 
     * @type {Array<Docs>}
     * @memberof GetDocsResponse
     */
    contents: Array<Docs>;
    /**
     * 
     * @type {number}
     * @memberof GetDocsResponse
     */
    totalCounts: number;
    /**
     * 
     * @type {number}
     * @memberof GetDocsResponse
     */
    offset: number;
    /**
     * 
     * @type {number}
     * @memberof GetDocsResponse
     */
    limit: number;
}
/**
 * 
 * @export
 * @interface GetDocsResponseAllOf
 */
export interface GetDocsResponseAllOf {
    /**
     * 
     * @type {Array<Docs>}
     * @memberof GetDocsResponseAllOf
     */
    contents: Array<Docs>;
}
/**
 * 
 * @export
 * @interface GetNewsResponse
 */
export interface GetNewsResponse {
    /**
     * 
     * @type {Array<News>}
     * @memberof GetNewsResponse
     */
    contents: Array<News>;
    /**
     * 
     * @type {number}
     * @memberof GetNewsResponse
     */
    totalCounts: number;
    /**
     * 
     * @type {number}
     * @memberof GetNewsResponse
     */
    offset: number;
    /**
     * 
     * @type {number}
     * @memberof GetNewsResponse
     */
    limit: number;
}
/**
 * 
 * @export
 * @interface GetNewsResponseAllOf
 */
export interface GetNewsResponseAllOf {
    /**
     * 
     * @type {Array<News>}
     * @memberof GetNewsResponseAllOf
     */
    contents: Array<News>;
}
/**
 * 
 * @export
 * @interface GetProductsResponse
 */
export interface GetProductsResponse {
    /**
     * 
     * @type {Array<Product>}
     * @memberof GetProductsResponse
     */
    contents: Array<Product>;
    /**
     * 
     * @type {number}
     * @memberof GetProductsResponse
     */
    totalCounts: number;
    /**
     * 
     * @type {number}
     * @memberof GetProductsResponse
     */
    offset: number;
    /**
     * 
     * @type {number}
     * @memberof GetProductsResponse
     */
    limit: number;
}
/**
 * 
 * @export
 * @interface GetProductsResponseAllOf
 */
export interface GetProductsResponseAllOf {
    /**
     * 
     * @type {Array<Product>}
     * @memberof GetProductsResponseAllOf
     */
    contents: Array<Product>;
}
/**
 * 
 * @export
 * @interface GetTagsResponse
 */
export interface GetTagsResponse {
    /**
     * 
     * @type {Array<ProductTag>}
     * @memberof GetTagsResponse
     */
    contents: Array<ProductTag>;
    /**
     * 
     * @type {number}
     * @memberof GetTagsResponse
     */
    totalCounts: number;
    /**
     * 
     * @type {number}
     * @memberof GetTagsResponse
     */
    offset: number;
    /**
     * 
     * @type {number}
     * @memberof GetTagsResponse
     */
    limit: number;
}
/**
 * 
 * @export
 * @interface GetTagsResponseAllOf
 */
export interface GetTagsResponseAllOf {
    /**
     * 
     * @type {Array<ProductTag>}
     * @memberof GetTagsResponseAllOf
     */
    contents: Array<ProductTag>;
}
/**
 * 
 * @export
 * @interface GetTosResponse
 */
export interface GetTosResponse {
    /**
     * 
     * @type {Array<Tos>}
     * @memberof GetTosResponse
     */
    contents: Array<Tos>;
    /**
     * 
     * @type {number}
     * @memberof GetTosResponse
     */
    totalCounts: number;
    /**
     * 
     * @type {number}
     * @memberof GetTosResponse
     */
    offset: number;
    /**
     * 
     * @type {number}
     * @memberof GetTosResponse
     */
    limit: number;
}
/**
 * 
 * @export
 * @interface GetTosResponseAllOf
 */
export interface GetTosResponseAllOf {
    /**
     * 
     * @type {Array<Tos>}
     * @memberof GetTosResponseAllOf
     */
    contents: Array<Tos>;
}
/**
 * 
 * @export
 * @interface GetTutorialsResponse
 */
export interface GetTutorialsResponse {
    /**
     * 
     * @type {Array<Tutorial>}
     * @memberof GetTutorialsResponse
     */
    contents: Array<Tutorial>;
    /**
     * 
     * @type {number}
     * @memberof GetTutorialsResponse
     */
    totalCounts: number;
    /**
     * 
     * @type {number}
     * @memberof GetTutorialsResponse
     */
    offset: number;
    /**
     * 
     * @type {number}
     * @memberof GetTutorialsResponse
     */
    limit: number;
}
/**
 * 
 * @export
 * @interface GetTutorialsResponseAllOf
 */
export interface GetTutorialsResponseAllOf {
    /**
     * 
     * @type {Array<Tutorial>}
     * @memberof GetTutorialsResponseAllOf
     */
    contents: Array<Tutorial>;
}
/**
 * 
 * @export
 * @interface News
 */
export interface News {
    /**
     * 
     * @type {string}
     * @memberof News
     */
    title: string;
    /**
     * 
     * @type {Date}
     * @memberof News
     */
    date: Date;
    /**
     * 
     * @type {string}
     * @memberof News
     */
    link?: string;
    /**
     * 
     * @type {string}
     * @memberof News
     */
    id: string;
    /**
     * 
     * @type {Date}
     * @memberof News
     */
    createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof News
     */
    updatedAt: Date;
}
/**
 * 
 * @export
 * @interface NewsAllOf
 */
export interface NewsAllOf {
    /**
     * 
     * @type {string}
     * @memberof NewsAllOf
     */
    title: string;
    /**
     * 
     * @type {Date}
     * @memberof NewsAllOf
     */
    date: Date;
    /**
     * 
     * @type {string}
     * @memberof NewsAllOf
     */
    link?: string;
}
/**
 * 
 * @export
 * @interface Notice
 */
export interface Notice {
    /**
     * 
     * @type {string}
     * @memberof Notice
     */
    content?: string;
    /**
     * 
     * @type {Date}
     * @memberof Notice
     */
    displayStartDate?: Date;
    /**
     * 
     * @type {Date}
     * @memberof Notice
     */
    displayEndDate?: Date;
    /**
     * 
     * @type {string}
     * @memberof Notice
     */
    id: string;
    /**
     * 
     * @type {Date}
     * @memberof Notice
     */
    createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof Notice
     */
    updatedAt: Date;
}
/**
 * 
 * @export
 * @interface NoticeAllOf
 */
export interface NoticeAllOf {
    /**
     * 
     * @type {string}
     * @memberof NoticeAllOf
     */
    content?: string;
    /**
     * 
     * @type {Date}
     * @memberof NoticeAllOf
     */
    displayStartDate?: Date;
    /**
     * 
     * @type {Date}
     * @memberof NoticeAllOf
     */
    displayEndDate?: Date;
}
/**
 * 
 * @export
 * @interface Pagination
 */
export interface Pagination {
    /**
     * 
     * @type {number}
     * @memberof Pagination
     */
    totalCounts: number;
    /**
     * 
     * @type {number}
     * @memberof Pagination
     */
    offset: number;
    /**
     * 
     * @type {number}
     * @memberof Pagination
     */
    limit: number;
}
/**
 * 
 * @export
 * @interface Product
 */
export interface Product {
    /**
     * 
     * @type {number}
     * @memberof Product
     */
    order: number;
    /**
     * 
     * @type {string}
     * @memberof Product
     */
    productName: string;
    /**
     * 
     * @type {string}
     * @memberof Product
     */
    outline: string;
    /**
     * 
     * @type {string}
     * @memberof Product
     */
    description: string;
    /**
     * 
     * @type {string}
     * @memberof Product
     */
    provider: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof Product
     */
    type: Array<ProductTypeEnum>;
    /**
     * 
     * @type {string}
     * @memberof Product
     */
    details: string;
    /**
     * 
     * @type {ProductAllOfSwagger}
     * @memberof Product
     */
    swagger?: ProductAllOfSwagger;
    /**
     * 
     * @type {string}
     * @memberof Product
     */
    faq: string;
    /**
     * 
     * @type {string}
     * @memberof Product
     */
    tosType: string;
    /**
     * 
     * @type {string}
     * @memberof Product
     */
    tosText: string;
    /**
     * 
     * @type {string}
     * @memberof Product
     */
    tosPdf: string;
    /**
     * 
     * @type {ProductAllOfSwagger}
     * @memberof Product
     */
    logo: ProductAllOfSwagger;
    /**
     * 
     * @type {Array<ProductTag>}
     * @memberof Product
     */
    tags?: Array<ProductTag>;
    /**
     * 
     * @type {ProductAllOfSwagger}
     * @memberof Product
     */
    ratePlan?: ProductAllOfSwagger;
    /**
     * 
     * @type {string}
     * @memberof Product
     */
    planName?: string;
    /**
     * 
     * @type {string}
     * @memberof Product
     */
    planDescription?: string;
    /**
     * 
     * @type {string}
     * @memberof Product
     */
    id: string;
    /**
     * 
     * @type {Date}
     * @memberof Product
     */
    createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof Product
     */
    updatedAt: Date;
}

/**
    * @export
    * @enum {string}
    */
export enum ProductTypeEnum {
    InHouseAPI = 'InHouseAPI',
    _3rdPartyAPI = '3rdPartyAPI',
    Software = 'Software',
    ComingSoon = 'ComingSoon'
}

/**
 * 
 * @export
 * @interface ProductAllOf
 */
export interface ProductAllOf {
    /**
     * 
     * @type {number}
     * @memberof ProductAllOf
     */
    order: number;
    /**
     * 
     * @type {string}
     * @memberof ProductAllOf
     */
    productName: string;
    /**
     * 
     * @type {string}
     * @memberof ProductAllOf
     */
    outline: string;
    /**
     * 
     * @type {string}
     * @memberof ProductAllOf
     */
    description: string;
    /**
     * 
     * @type {string}
     * @memberof ProductAllOf
     */
    provider: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ProductAllOf
     */
    type: Array<ProductAllOfTypeEnum>;
    /**
     * 
     * @type {string}
     * @memberof ProductAllOf
     */
    details: string;
    /**
     * 
     * @type {ProductAllOfSwagger}
     * @memberof ProductAllOf
     */
    swagger?: ProductAllOfSwagger;
    /**
     * 
     * @type {string}
     * @memberof ProductAllOf
     */
    faq: string;
    /**
     * 
     * @type {string}
     * @memberof ProductAllOf
     */
    tosType: string;
    /**
     * 
     * @type {string}
     * @memberof ProductAllOf
     */
    tosText: string;
    /**
     * 
     * @type {string}
     * @memberof ProductAllOf
     */
    tosPdf: string;
    /**
     * 
     * @type {ProductAllOfSwagger}
     * @memberof ProductAllOf
     */
    logo: ProductAllOfSwagger;
    /**
     * 
     * @type {Array<ProductTag>}
     * @memberof ProductAllOf
     */
    tags?: Array<ProductTag>;
    /**
     * 
     * @type {ProductAllOfSwagger}
     * @memberof ProductAllOf
     */
    ratePlan?: ProductAllOfSwagger;
    /**
     * 
     * @type {string}
     * @memberof ProductAllOf
     */
    planName?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductAllOf
     */
    planDescription?: string;
}

/**
    * @export
    * @enum {string}
    */
export enum ProductAllOfTypeEnum {
    InHouseAPI = 'InHouseAPI',
    _3rdPartyAPI = '3rdPartyAPI',
    Software = 'Software',
    ComingSoon = 'ComingSoon'
}

/**
 * 
 * @export
 * @interface ProductAllOfSwagger
 */
export interface ProductAllOfSwagger {
    /**
     * 
     * @type {string}
     * @memberof ProductAllOfSwagger
     */
    url?: string;
}
/**
 * 
 * @export
 * @interface ProductTag
 */
export interface ProductTag {
    /**
     * 
     * @type {string}
     * @memberof ProductTag
     */
    tagName: string;
    /**
     * 
     * @type {number}
     * @memberof ProductTag
     */
    order: number;
    /**
     * 
     * @type {string}
     * @memberof ProductTag
     */
    tagIcon?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductTag
     */
    id: string;
    /**
     * 
     * @type {Date}
     * @memberof ProductTag
     */
    createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof ProductTag
     */
    updatedAt: Date;
}
/**
 * 
 * @export
 * @interface ProductTagAllOf
 */
export interface ProductTagAllOf {
    /**
     * 
     * @type {string}
     * @memberof ProductTagAllOf
     */
    tagName: string;
    /**
     * 
     * @type {number}
     * @memberof ProductTagAllOf
     */
    order: number;
    /**
     * 
     * @type {string}
     * @memberof ProductTagAllOf
     */
    tagIcon?: string;
}
/**
 * 
 * @export
 * @interface Step
 */
export interface Step {
    /**
     * 
     * @type {string}
     * @memberof Step
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof Step
     */
    description: string;
    /**
     * 
     * @type {ProductAllOfSwagger}
     * @memberof Step
     */
    mainImage?: ProductAllOfSwagger;
    /**
     * 
     * @type {string}
     * @memberof Step
     */
    fieldId: string;
}
/**
 * 
 * @export
 * @interface StepAllOf
 */
export interface StepAllOf {
    /**
     * 
     * @type {string}
     * @memberof StepAllOf
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof StepAllOf
     */
    description: string;
    /**
     * 
     * @type {ProductAllOfSwagger}
     * @memberof StepAllOf
     */
    mainImage?: ProductAllOfSwagger;
}
/**
 * 
 * @export
 * @interface System
 */
export interface System {
    /**
     * 
     * @type {string}
     * @memberof System
     */
    id: string;
    /**
     * 
     * @type {Date}
     * @memberof System
     */
    createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof System
     */
    updatedAt: Date;
}
/**
 * 
 * @export
 * @interface Tos
 */
export interface Tos {
    /**
     * 
     * @type {string}
     * @memberof Tos
     */
    title: string;
    /**
     * 
     * @type {number}
     * @memberof Tos
     */
    order: number;
    /**
     * 
     * @type {string}
     * @memberof Tos
     */
    body: string;
    /**
     * 
     * @type {string}
     * @memberof Tos
     */
    id: string;
    /**
     * 
     * @type {Date}
     * @memberof Tos
     */
    createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof Tos
     */
    updatedAt: Date;
}
/**
 * 
 * @export
 * @interface TosAllOf
 */
export interface TosAllOf {
    /**
     * 
     * @type {string}
     * @memberof TosAllOf
     */
    title: string;
    /**
     * 
     * @type {number}
     * @memberof TosAllOf
     */
    order: number;
    /**
     * 
     * @type {string}
     * @memberof TosAllOf
     */
    body: string;
}
/**
 * 
 * @export
 * @interface Tutorial
 */
export interface Tutorial {
    /**
     * 
     * @type {string}
     * @memberof Tutorial
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof Tutorial
     */
    overview: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof Tutorial
     */
    category: Array<TutorialCategoryEnum>;
    /**
     * 
     * @type {ProductAllOfSwagger}
     * @memberof Tutorial
     */
    demo?: ProductAllOfSwagger;
    /**
     * 
     * @type {string}
     * @memberof Tutorial
     */
    devenv?: string;
    /**
     * 
     * @type {Array<Product>}
     * @memberof Tutorial
     */
    products?: Array<Product>;
    /**
     * 
     * @type {Array<Step>}
     * @memberof Tutorial
     */
    steps?: Array<Step>;
    /**
     * 
     * @type {string}
     * @memberof Tutorial
     */
    id: string;
    /**
     * 
     * @type {Date}
     * @memberof Tutorial
     */
    createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof Tutorial
     */
    updatedAt: Date;
}

/**
    * @export
    * @enum {string}
    */
export enum TutorialCategoryEnum {
    CATEGORY_MANUAL = '利用マニュアル',
    CATEGORY_POC = 'プロダクト活用例'
}

/**
 * 
 * @export
 * @interface TutorialAllOf
 */
export interface TutorialAllOf {
    /**
     * 
     * @type {string}
     * @memberof TutorialAllOf
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof TutorialAllOf
     */
    overview: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof TutorialAllOf
     */
    category: Array<TutorialAllOfCategoryEnum>;
    /**
     * 
     * @type {ProductAllOfSwagger}
     * @memberof TutorialAllOf
     */
    demo?: ProductAllOfSwagger;
    /**
     * 
     * @type {string}
     * @memberof TutorialAllOf
     */
    devenv?: string;
    /**
     * 
     * @type {Array<Product>}
     * @memberof TutorialAllOf
     */
    products?: Array<Product>;
    /**
     * 
     * @type {Array<Step>}
     * @memberof TutorialAllOf
     */
    steps?: Array<Step>;
}

/**
    * @export
    * @enum {string}
    */
export enum TutorialAllOfCategoryEnum {
    CATEGORY_MANUAL = '利用マニュアル',
    CATEGORY_POC = 'プロダクト活用例'
}


/**
 * DocsApi - axios parameter creator
 * @export
 */
export const DocsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * ディベロッパーガイドのコンテンツ一覧を取得します。
         * @summary ディベロッパーガイドコンテンツ取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDocs(options: any = {}): RequestArgs {
            const localVarPath = `/docs`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication apiKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-MICROCMS-API-KEY")
                    : configuration.apiKey;
                localVarHeaderParameter["X-MICROCMS-API-KEY"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DocsApi - functional programming interface
 * @export
 */
export const DocsApiFp = function(configuration?: Configuration) {
    return {
        /**
         * ディベロッパーガイドのコンテンツ一覧を取得します。
         * @summary ディベロッパーガイドコンテンツ取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDocs(options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetDocsResponse> {
            const localVarAxiosArgs = DocsApiAxiosParamCreator(configuration).getDocs(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * DocsApi - factory interface
 * @export
 */
export const DocsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * ディベロッパーガイドのコンテンツ一覧を取得します。
         * @summary ディベロッパーガイドコンテンツ取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDocs(options?: any) {
            return DocsApiFp(configuration).getDocs(options)(axios, basePath);
        },
    };
};

/**
 * DocsApi - object-oriented interface
 * @export
 * @class DocsApi
 * @extends {BaseAPI}
 */
export class DocsApi extends BaseAPI {
    /**
     * ディベロッパーガイドのコンテンツ一覧を取得します。
     * @summary ディベロッパーガイドコンテンツ取得
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocsApi
     */
    public getDocs(options?: any) {
        return DocsApiFp(this.configuration).getDocs(options)(this.axios, this.basePath);
    }

}


/**
 * NewsApi - axios parameter creator
 * @export
 */
export const NewsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * ニュースのコンテンツ一覧を取得します。
         * @summary ニュースコンテンツ取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNews(options: any = {}): RequestArgs {
            const localVarPath = `/news`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication apiKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-MICROCMS-API-KEY")
                    : configuration.apiKey;
                localVarHeaderParameter["X-MICROCMS-API-KEY"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * NewsApi - functional programming interface
 * @export
 */
export const NewsApiFp = function(configuration?: Configuration) {
    return {
        /**
         * ニュースのコンテンツ一覧を取得します。
         * @summary ニュースコンテンツ取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNews(options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetNewsResponse> {
            const localVarAxiosArgs = NewsApiAxiosParamCreator(configuration).getNews(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * NewsApi - factory interface
 * @export
 */
export const NewsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * ニュースのコンテンツ一覧を取得します。
         * @summary ニュースコンテンツ取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNews(options?: any) {
            return NewsApiFp(configuration).getNews(options)(axios, basePath);
        },
    };
};

/**
 * NewsApi - object-oriented interface
 * @export
 * @class NewsApi
 * @extends {BaseAPI}
 */
export class NewsApi extends BaseAPI {
    /**
     * ニュースのコンテンツ一覧を取得します。
     * @summary ニュースコンテンツ取得
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NewsApi
     */
    public getNews(options?: any) {
        return NewsApiFp(this.configuration).getNews(options)(this.axios, this.basePath);
    }

}


/**
 * NoticeApi - axios parameter creator
 * @export
 */
export const NoticeApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 重要なお知らせのコンテンツを取得します。
         * @summary 重要なお知らせコンテンツ取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNotice(options: any = {}): RequestArgs {
            const localVarPath = `/notice`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication apiKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-MICROCMS-API-KEY")
                    : configuration.apiKey;
                localVarHeaderParameter["X-MICROCMS-API-KEY"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * NoticeApi - functional programming interface
 * @export
 */
export const NoticeApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 重要なお知らせのコンテンツを取得します。
         * @summary 重要なお知らせコンテンツ取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNotice(options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Notice> {
            const localVarAxiosArgs = NoticeApiAxiosParamCreator(configuration).getNotice(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * NoticeApi - factory interface
 * @export
 */
export const NoticeApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 重要なお知らせのコンテンツを取得します。
         * @summary 重要なお知らせコンテンツ取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNotice(options?: any) {
            return NoticeApiFp(configuration).getNotice(options)(axios, basePath);
        },
    };
};

/**
 * NoticeApi - object-oriented interface
 * @export
 * @class NoticeApi
 * @extends {BaseAPI}
 */
export class NoticeApi extends BaseAPI {
    /**
     * 重要なお知らせのコンテンツを取得します。
     * @summary 重要なお知らせコンテンツ取得
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NoticeApi
     */
    public getNotice(options?: any) {
        return NoticeApiFp(this.configuration).getNotice(options)(this.axios, this.basePath);
    }

}


/**
 * ProductApi - axios parameter creator
 * @export
 */
export const ProductApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * コンテンツIDで指定した商品のコンテンツを取得します。
         * @summary 商品コンテンツ参照
         * @param {string} contentId コンテンツID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductByContentId(contentId: string, options: any = {}): RequestArgs {
            // verify required parameter 'contentId' is not null or undefined
            if (contentId === null || contentId === undefined) {
                throw new RequiredError('contentId','Required parameter contentId was null or undefined when calling getProductByContentId.');
            }
            const localVarPath = `/products/{content_id}`
                .replace(`{${"content_id"}}`, encodeURIComponent(String(contentId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication apiKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-MICROCMS-API-KEY")
                    : configuration.apiKey;
                localVarHeaderParameter["X-MICROCMS-API-KEY"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 商品のコンテンツ一覧を取得します。
         * @summary 商品コンテンツ取得
         * @param {number} [limit] 取得上限
         * @param {number} [offset] オフセット
         * @param {string} [orders] 取得順序
         * @param {string} [q] 全文検索
         * @param {string} [filters] コンテンツフィルタ
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProducts(limit?: number, offset?: number, orders?: string, q?: string, filters?: string, options: any = {}): RequestArgs {
            const localVarPath = `/products`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication apiKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-MICROCMS-API-KEY")
                    : configuration.apiKey;
                localVarHeaderParameter["X-MICROCMS-API-KEY"] = localVarApiKeyValue;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (orders !== undefined) {
                localVarQueryParameter['orders'] = orders;
            }

            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }

            if (filters !== undefined) {
                localVarQueryParameter['filters'] = filters;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProductApi - functional programming interface
 * @export
 */
export const ProductApiFp = function(configuration?: Configuration) {
    return {
        /**
         * コンテンツIDで指定した商品のコンテンツを取得します。
         * @summary 商品コンテンツ参照
         * @param {string} contentId コンテンツID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductByContentId(contentId: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Product> {
            const localVarAxiosArgs = ProductApiAxiosParamCreator(configuration).getProductByContentId(contentId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 商品のコンテンツ一覧を取得します。
         * @summary 商品コンテンツ取得
         * @param {number} [limit] 取得上限
         * @param {number} [offset] オフセット
         * @param {string} [orders] 取得順序
         * @param {string} [q] 全文検索
         * @param {string} [filters] コンテンツフィルタ
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProducts(limit?: number, offset?: number, orders?: string, q?: string, filters?: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetProductsResponse> {
            const localVarAxiosArgs = ProductApiAxiosParamCreator(configuration).getProducts(limit, offset, orders, q, filters, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * ProductApi - factory interface
 * @export
 */
export const ProductApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * コンテンツIDで指定した商品のコンテンツを取得します。
         * @summary 商品コンテンツ参照
         * @param {string} contentId コンテンツID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductByContentId(contentId: string, options?: any) {
            return ProductApiFp(configuration).getProductByContentId(contentId, options)(axios, basePath);
        },
        /**
         * 商品のコンテンツ一覧を取得します。
         * @summary 商品コンテンツ取得
         * @param {number} [limit] 取得上限
         * @param {number} [offset] オフセット
         * @param {string} [orders] 取得順序
         * @param {string} [q] 全文検索
         * @param {string} [filters] コンテンツフィルタ
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProducts(limit?: number, offset?: number, orders?: string, q?: string, filters?: string, options?: any) {
            return ProductApiFp(configuration).getProducts(limit, offset, orders, q, filters, options)(axios, basePath);
        },
    };
};

/**
 * ProductApi - object-oriented interface
 * @export
 * @class ProductApi
 * @extends {BaseAPI}
 */
export class ProductApi extends BaseAPI {
    /**
     * コンテンツIDで指定した商品のコンテンツを取得します。
     * @summary 商品コンテンツ参照
     * @param {string} contentId コンテンツID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductApi
     */
    public getProductByContentId(contentId: string, options?: any) {
        return ProductApiFp(this.configuration).getProductByContentId(contentId, options)(this.axios, this.basePath);
    }

    /**
     * 商品のコンテンツ一覧を取得します。
     * @summary 商品コンテンツ取得
     * @param {number} [limit] 取得上限
     * @param {number} [offset] オフセット
     * @param {string} [orders] 取得順序
     * @param {string} [q] 全文検索
     * @param {string} [filters] コンテンツフィルタ
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductApi
     */
    public getProducts(limit?: number, offset?: number, orders?: string, q?: string, filters?: string, options?: any) {
        return ProductApiFp(this.configuration).getProducts(limit, offset, orders, q, filters, options)(this.axios, this.basePath);
    }

}


/**
 * ProductTagApi - axios parameter creator
 * @export
 */
export const ProductTagApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 商品タグのコンテンツ一覧を取得します。
         * @summary 商品タグコンテンツ参照
         * @param {number} [limit] 取得上限
         * @param {number} [offset] オフセット
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductTags(limit?: number, offset?: number, options: any = {}): RequestArgs {
            const localVarPath = `/product-tags`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication apiKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-MICROCMS-API-KEY")
                    : configuration.apiKey;
                localVarHeaderParameter["X-MICROCMS-API-KEY"] = localVarApiKeyValue;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProductTagApi - functional programming interface
 * @export
 */
export const ProductTagApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 商品タグのコンテンツ一覧を取得します。
         * @summary 商品タグコンテンツ参照
         * @param {number} [limit] 取得上限
         * @param {number} [offset] オフセット
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductTags(limit?: number, offset?: number, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetTagsResponse> {
            const localVarAxiosArgs = ProductTagApiAxiosParamCreator(configuration).getProductTags(limit, offset, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * ProductTagApi - factory interface
 * @export
 */
export const ProductTagApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 商品タグのコンテンツ一覧を取得します。
         * @summary 商品タグコンテンツ参照
         * @param {number} [limit] 取得上限
         * @param {number} [offset] オフセット
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductTags(limit?: number, offset?: number, options?: any) {
            return ProductTagApiFp(configuration).getProductTags(limit, offset, options)(axios, basePath);
        },
    };
};

/**
 * ProductTagApi - object-oriented interface
 * @export
 * @class ProductTagApi
 * @extends {BaseAPI}
 */
export class ProductTagApi extends BaseAPI {
    /**
     * 商品タグのコンテンツ一覧を取得します。
     * @summary 商品タグコンテンツ参照
     * @param {number} [limit] 取得上限
     * @param {number} [offset] オフセット
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductTagApi
     */
    public getProductTags(limit?: number, offset?: number, options?: any) {
        return ProductTagApiFp(this.configuration).getProductTags(limit, offset, options)(this.axios, this.basePath);
    }

}


/**
 * TosApi - axios parameter creator
 * @export
 */
export const TosApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 利用規約のコンテンツ一覧を取得します。
         * @summary 利用規約コンテンツ取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTos(options: any = {}): RequestArgs {
            const localVarPath = `/tos`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication apiKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-MICROCMS-API-KEY")
                    : configuration.apiKey;
                localVarHeaderParameter["X-MICROCMS-API-KEY"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TosApi - functional programming interface
 * @export
 */
export const TosApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 利用規約のコンテンツ一覧を取得します。
         * @summary 利用規約コンテンツ取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTos(options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetTosResponse> {
            const localVarAxiosArgs = TosApiAxiosParamCreator(configuration).getTos(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * TosApi - factory interface
 * @export
 */
export const TosApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 利用規約のコンテンツ一覧を取得します。
         * @summary 利用規約コンテンツ取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTos(options?: any) {
            return TosApiFp(configuration).getTos(options)(axios, basePath);
        },
    };
};

/**
 * TosApi - object-oriented interface
 * @export
 * @class TosApi
 * @extends {BaseAPI}
 */
export class TosApi extends BaseAPI {
    /**
     * 利用規約のコンテンツ一覧を取得します。
     * @summary 利用規約コンテンツ取得
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TosApi
     */
    public getTos(options?: any) {
        return TosApiFp(this.configuration).getTos(options)(this.axios, this.basePath);
    }

}


/**
 * TutorialApi - axios parameter creator
 * @export
 */
export const TutorialApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * コンテンツIDで指定したチュートリアルのコンテンツを取得します。
         * @summary チュートリアルコンテンツ参照
         * @param {string} contentId コンテンツID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTutorialByContentId(contentId: string, options: any = {}): RequestArgs {
            // verify required parameter 'contentId' is not null or undefined
            if (contentId === null || contentId === undefined) {
                throw new RequiredError('contentId','Required parameter contentId was null or undefined when calling getTutorialByContentId.');
            }
            const localVarPath = `/tutorials/{content_id}`
                .replace(`{${"content_id"}}`, encodeURIComponent(String(contentId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication apiKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-MICROCMS-API-KEY")
                    : configuration.apiKey;
                localVarHeaderParameter["X-MICROCMS-API-KEY"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * チュートリアルのコンテンツ一覧を取得します。
         * @summary チュートリアルコンテンツ取得
         * @param {number} [limit] 取得上限
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTutorials(limit?: number, options: any = {}): RequestArgs {
            const localVarPath = `/tutorials`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication apiKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-MICROCMS-API-KEY")
                    : configuration.apiKey;
                localVarHeaderParameter["X-MICROCMS-API-KEY"] = localVarApiKeyValue;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TutorialApi - functional programming interface
 * @export
 */
export const TutorialApiFp = function(configuration?: Configuration) {
    return {
        /**
         * コンテンツIDで指定したチュートリアルのコンテンツを取得します。
         * @summary チュートリアルコンテンツ参照
         * @param {string} contentId コンテンツID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTutorialByContentId(contentId: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Tutorial> {
            const localVarAxiosArgs = TutorialApiAxiosParamCreator(configuration).getTutorialByContentId(contentId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * チュートリアルのコンテンツ一覧を取得します。
         * @summary チュートリアルコンテンツ取得
         * @param {number} [limit] 取得上限
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTutorials(limit?: number, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetTutorialsResponse> {
            const localVarAxiosArgs = TutorialApiAxiosParamCreator(configuration).getTutorials(limit, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * TutorialApi - factory interface
 * @export
 */
export const TutorialApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * コンテンツIDで指定したチュートリアルのコンテンツを取得します。
         * @summary チュートリアルコンテンツ参照
         * @param {string} contentId コンテンツID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTutorialByContentId(contentId: string, options?: any) {
            return TutorialApiFp(configuration).getTutorialByContentId(contentId, options)(axios, basePath);
        },
        /**
         * チュートリアルのコンテンツ一覧を取得します。
         * @summary チュートリアルコンテンツ取得
         * @param {number} [limit] 取得上限
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTutorials(limit?: number, options?: any) {
            return TutorialApiFp(configuration).getTutorials(limit, options)(axios, basePath);
        },
    };
};

/**
 * TutorialApi - object-oriented interface
 * @export
 * @class TutorialApi
 * @extends {BaseAPI}
 */
export class TutorialApi extends BaseAPI {
    /**
     * コンテンツIDで指定したチュートリアルのコンテンツを取得します。
     * @summary チュートリアルコンテンツ参照
     * @param {string} contentId コンテンツID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TutorialApi
     */
    public getTutorialByContentId(contentId: string, options?: any) {
        return TutorialApiFp(this.configuration).getTutorialByContentId(contentId, options)(this.axios, this.basePath);
    }

    /**
     * チュートリアルのコンテンツ一覧を取得します。
     * @summary チュートリアルコンテンツ取得
     * @param {number} [limit] 取得上限
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TutorialApi
     */
    public getTutorials(limit?: number, options?: any) {
        return TutorialApiFp(this.configuration).getTutorials(limit, options)(this.axios, this.basePath);
    }

}


